import { type BundleArchivedFilterOptions } from './BundleStore'

/**
 * Query string builder for the Bundle Search API.
 */
export class BundleRequestQueryFilterBuilder {
  archivedStatus?: BundleArchivedFilterOptions = undefined

  /**
   * Filter by archived status.
   */
  withArchivedStatus(
    archivedStatus: BundleArchivedFilterOptions,
  ): BundleRequestQueryFilterBuilder {
    if (archivedStatus === undefined) {
      return this
    }
    this.archivedStatus = archivedStatus
    return this
  }

  /**
   * Builds the query string.
   */
  build(): string {
    const queryParts = []

    if (this.archivedStatus !== undefined) {
      queryParts.push(
        `archived=${mapArchivedFilterOptionToQueryValue(this.archivedStatus)}`,
      )
    }

    return queryParts.join(' AND ')
  }
}

function mapArchivedFilterOptionToQueryValue(
  archivedStatus: BundleArchivedFilterOptions,
) {
  switch (archivedStatus) {
    case 'Active':
      return 'ACTIVE'
    case 'Archived':
      return 'ARCHIVED'
  }
}
